export const ANTIFRAUD_LIMIT_NUMBER = 10;
